export enum RequestableType {
  PROJECT = 'Project',
  COMPANY = 'Company',
  DEVICE = 'Device',
  RUUVI_TAG = 'RuuviTag',
  USER = 'User'
}
